module.exports = __webpack_public_path__ + "static/media/IMG_2184.d8b061a6.jpg";